@if (vm$ | async; as vm) {
  @if (vm.show && vm.v2) {
    <div
      class="whatsapp-credits-alert -v2"
      [ngClass]="vm.variation"
      [class.-blocked]="vm.blocked"
      data-testid="whatsapp-credits-alert"
    >
      <app-icon
        class="whatsapp-credits-alert__icon"
        [class.whatsapp-credits-alert__icon--pulse]="vm.worstLevel >= 2"
        [name]="vm.blocked ? 'dangerous' : 'warning'"
        matFontSet="material-symbols-outlined"
        [size]="20"
      />
      <p class="whatsapp-credits-alert__text">
        {{ 'CREDITS_BALANCE.' + vm.messageKey | translate: { company: vm.companyName } }} •
        <button
          type="button"
          class="whatsapp-credits-alert__link"
          (click)="open()"
          data-testid="whatsapp-credits-alert-view"
        >{{ 'CREDITS_BALANCE.' + vm.ctaKey | translate }}</button>
      </p>
      <a
        class="whatsapp-credits-alert__buy"
        [href]="(canManageCredits$ | async) ? creditsStatementUrl : ('CREDITS_BALANCE_V2.BUY_HELP_URL' | translate)"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-credits-alert-buy"
      >
        <span>{{ 'CREDITS_BALANCE.BUY' | translate }}</span>
        <app-icon name="open_in_new" matFontSet="material-symbols-outlined" [size]="20" />
      </a>
      <button
        type="button"
        class="whatsapp-credits-alert__close"
        (click)="dismiss($event)"
        [attr.aria-label]="'CREDITS_BALANCE.ALERT_CLOSE' | translate"
        data-testid="whatsapp-credits-alert-close"
      >
        <app-icon name="close" matFontSet="material-symbols-outlined" [size]="20" />
      </button>
    </div>
  } @else if (vm.show) {
    <div
      class="whatsapp-credits-alert"
      [ngClass]="vm.variation"
      role="button"
      tabindex="0"
      (click)="open()"
      (keydown.enter)="open()"
      (keydown.space)="open()"
      data-testid="whatsapp-credits-alert"
    >
      <app-icon
        class="whatsapp-credits-alert__icon"
        [class.whatsapp-credits-alert__icon--pulse]="vm.worstLevel >= 2"
        name="warning"
        matFontSet="material-symbols-outlined"
        [size]="24"
      />
      <span class="whatsapp-credits-alert__message">
        {{ 'CREDITS_BALANCE.' + vm.messageKey | translate: { company: vm.companyName } }}
      </span>
      <span class="whatsapp-credits-alert__cta">
        {{ 'CREDITS_BALANCE.' + vm.ctaKey | translate }}
      </span>
      <div class="whatsapp-credits-alert__spacer"></div>
      <button
        type="button"
        class="whatsapp-credits-alert__close"
        (click)="dismiss($event)"
        [attr.aria-label]="'CREDITS_BALANCE.ALERT_CLOSE' | translate"
        data-testid="whatsapp-credits-alert-close"
      >
        <app-icon name="close" matFontSet="material-symbols-outlined" [size]="20" />
      </button>
    </div>
  }
}
